import "../../lib/jquery.magnific-popup.js";

export function init() {
	$('.js-product-buy-options-modal').each(function () {
		let $this = $(this);
		$this.on('click', function (e) {
			e.preventDefault();

			let href = $(this).attr('href');

			$('body').addClass('iframe-product-buy-options');

			($ as any).magnificPopup.open({
				items: {
					src: href
				},
				iframe: {
					markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
					'</div>'
				},
				type: 'iframe',
				mainClass: 'modal-zoom'
			});
		})
	});
}
